import { render } from "./humanityCourseManager.vue?vue&type=template&id=6d747354&scoped=true"
import script from "./humanityCourseManager.vue?vue&type=script&lang=js"
export * from "./humanityCourseManager.vue?vue&type=script&lang=js"

import "./humanityCourseManager.vue?vue&type=style&index=0&id=6d747354&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d747354"]])

export default __exports__